export default {
      id: "angle-right-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "assets/svg/icons.svg#angle-right-usage",
      toString: function () {
        return this.url;
      }
    }